import routes from "../constants/routes";
import { lazyLoadRoutes } from "../utils/lazy-loader";

export const userRoutes = [
  {
    path: "admin/user/list",
    element: lazyLoadRoutes("user/pages/admin"),
  },

  {
    path: "ess/user/list",
    element: lazyLoadRoutes("user/pages/ess"),
  },

  {
    path: "admin/role/list",
    element: lazyLoadRoutes("user/pages/admin-role"),
  },

  {
    path: "ess/role/list",
    element: lazyLoadRoutes("user/pages/ess-role"),
  },
  {
    path: routes.users.admin.adminRoleCreate,
    element: lazyLoadRoutes("user/pages/admin-role-create"),
  },
  {
    path: routes.users.ess.essRoleCreate,
    element: lazyLoadRoutes("user/pages/roles"),
  },
  {
    path: routes.users.ess.assignRoles,
    element: lazyLoadRoutes("user/pages/transfer-and-assign-roles"),
  },
  {
    path: routes.users.ess.mobileRights,
    element: lazyLoadRoutes("user/pages/user-access"),
  },
];
